import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';

interface TestimonialQuoteProps {
  quote: string;
  variant?: 'default' | 'tile';
}

export default function TestimonialQuote({
  quote,
  variant = 'default',
}: TestimonialQuoteProps) {
  return (
    <h3
      className={cn('bg-clip-text text-transparent', {
        'text-[24px] leading-normal lg:text-[32px]': variant === 'default',
        'text-[20px] leading-normal md:text-[18px]': variant === 'tile',
      })}
      style={{
        backgroundImage: `linear-gradient(270deg, ${colors.aqua50} -54.58%, ${colors.blue30} 100%)`,
      }}
    >
      {quote}
    </h3>
  );
}
